module.exports = __webpack_public_path__ + "img/bmi_splash.4c1585fc.jpg";